import { createAsyncThunk } from "@reduxjs/toolkit";

import * as conversationService from "../../services/conversation.service";

export const getChat = createAsyncThunk("chat/getChat", async () => {
    try {
        const response = await conversationService.getChat();
        return response;
    } catch (error) {
        return error;
    }
});

export const getChatDetail = createAsyncThunk("chat/getChatDetail", async (id: string) => {
    try {
        const response = await conversationService.getChatDetail(id);
        return response;
    } catch (error) {
        return error;
    }
});

export const sendMessage = createAsyncThunk("chat/sendMessage", async (payload: any, { dispatch }) => {
    try {
        const response = await conversationService.SendMessage(payload) as any;
        dispatch(getChatDetail(response.conversationId))
        dispatch(getChat())
        return response;
    } catch (error) {
        return error;
    }
});

export const sendMessageWithoutConversation = createAsyncThunk("chat/sendMessageWithoutConversation", async (payload: any, { dispatch }) => {
    try {
        const response = await conversationService.SendMessageWithoutConversation(payload) as any;
        if (!response) {
            return;
        }
        dispatch(getChatDetail(response.conversationId))
        dispatch(getChat())
        return response;
    } catch (error) {
        return error;
    }
});

export const updateStatusMessage = createAsyncThunk("chat/updateStatusMessage", async (messageId: string) => {
    try {
        const response = await conversationService.updateStatusMessage(messageId);
        return response;
    } catch (error) {
        return error;
    }
});

export const deleteChat = createAsyncThunk("Chat/deleteChat", async (id: string) => {
    try {
        const response = await conversationService.deleteChat(id);
        return response;
    } catch (error) {
        return error;
    }
});

export const changeAISuggestion = createAsyncThunk("Chat/changeAISuggestion", async ({ id, payload }: { id: string, payload: any }) => {
    try {
        const response = await conversationService.toggleEnableSuggestion(id, payload);
        return response;
    } catch (error) {
        return error;
    }
});

export const changeDisplayNotes = createAsyncThunk("Chat/changeDisplayNotes", async ({ id, payload }: { id: string, payload: any }) => {
    try {
        const response = await conversationService.toggleDisplayNotes(id, payload);
        return response;
    } catch (error) {
        return error;
    }
});

export const createActivityNotes = createAsyncThunk("Chat/createActivityNotes", async (id: string) => {
    try {
        const response = await conversationService.createActivityNotes(id);
        return response;
    } catch (error) {
        return error;
    }
});
